/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query PhoneNumberoReplacementReadQuery($type: CUSTOMER_TYPE!, $take: Int, $skip: Int, ) {
  PhoneNumberoReplacementRead(type: $type, take: $take, skip: $skip) {
    id,
    createdAt,
    updatedAt,
    type,
    status,
    message,
    CustomerAccount {
      displayName,
      id
    },
    Mcc {
      mcc,
      countryName
    },
    PhoneNumberoDirectory {
      id
      displayName
    }
  }
}
`
